// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3cWtV","footer":"ChangeClinic_footer__1V-wQ"};